/**
 * Convert Date object into formatted date string
 * @param {Date} date Input date object
 * @return {string} Formatted date (13. Juli 2018)
 */
export default function (date) {
  if (typeof date.getMonth !== 'function') {
    return 'Invalid Date'
  }

  return date.toLocaleDateString('de-DE', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  })
}
